import React from 'react'

const CheckMark = (props) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill={props.color ? props.color : '#1D79FB'} xmlns="http://www.w3.org/2000/svg">
    <path d="M5.98843 11.293L10.9382 16.2428L9.52397 17.657L4.57422 12.7072L5.98843 11.293Z" />
    <path d="M9.52396 14.8285L18.0092 6.34326L19.4235 7.75748L10.9382 16.2428L9.52396 14.8285Z"/>
  </svg>
)

export default CheckMark
